import { Encounter } from '../encounter';
import { EhrProviderInformationPractice } from '../user';
import { Patient } from '../patient';
import { ProvisionalPatient } from '../patient/provisional';
import { PrevisitFormSetWithForms } from './formSet';
import { PracticePreference } from '../previsit';

export enum ContactVerificationSource {
  Email = 'EMAIL',
  Sms = 'SMS',
}

export interface AllowedVerification {
  display: string;
  kind: ContactVerificationSource;
}

export interface RegistrationContactVerification {
  patient: ProvisionalPatient;
  contactVerification: boolean;
  allowedVerifications: AllowedVerification[];
}

export interface ProvisionalFormSetData {
  ehrProviderInformation: EhrProviderInformationPractice[];
  provisionalPatientId: string;
  patient: Patient;
  previsitFormSet: PrevisitFormSetWithForms & {
    authenticationCode: string;
    patientEhrId: string;
  };
  encounter: Encounter;
  practicePreference: PracticePreference;
}

export enum ReconciliationStatus {
  Success = 'SUCCESS',
  Fail = 'FAIL',
}
